import { formatMoney } from "@/utils/CommonUtils";
import { AspectRatio } from "@/v2-components/ui/aspect-ratio";
import Image from "next/image";
import { OrderItemV2 } from "@/models/orders/OrderDraft";
import { CurrencyIsoCode } from "@/enums";
import { useOrderItemSummary } from "@/hooks/useOrderItemSummary";

interface Props {
  item: OrderItemV2;
  currency: CurrencyIsoCode;
  countryCode: string;
}

export function OrderSummaryItem({ item, currency, countryCode }: Props) {
  const { displayDiscountAmount, displaySalePrice, displayOriginalPrice } =
    useOrderItemSummary(item);

  return (
    <div className="flex h-[120px] w-full items-center text-base">
      <div className="relative min-w-[84px] laptop:min-w-[100px]">
        <AspectRatio ratio={1}>
          <Image
            src={item.thumbnail}
            alt={item.name}
            className="h-full w-full rounded-md object-cover"
            fill
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          />
        </AspectRatio>
        <span className="absolute -right-[10px] -top-[10px] flex h-5 w-5 items-center justify-center rounded-full bg-blue-10 text-xs font-500 text-blue-60">
          {item.qty}
        </span>
      </div>
      <div className="flex flex-1 flex-col">
        <div className="flex items-center">
          <div className="ml-4 flex flex-1 flex-col gap-3 text-base">
            <p className="text-base font-600 laptop:text-lg">{item.name}</p>
            <p className="text-base capitalize">{item.options}</p>
          </div>
          <div className="ml-3 flex flex-col gap-1">
            {!!displayDiscountAmount && (
              <p className="text-base text-coolgray-50 line-through laptop:text-lg">
                {formatMoney({
                  amount: displayOriginalPrice * item.qty,
                  currency,
                  countryCode,
                })}
              </p>
            )}
            <p className="text-base font-600 laptop:text-lg">
              {formatMoney({
                amount: displaySalePrice * item.qty,
                currency,
                countryCode,
              })}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
